import React from "react";
import { useSelector } from "react-redux";
import DeckGLGoogleMap from "./DeckGLGoogleMap";

const Map = ({ selectedBranch }) => {
  const { lookupData } = useSelector((state) => state.branchesData);
  let coordinates = null,
    address = null,
    branches = null;

  if (lookupData) {
    coordinates = lookupData.coordinates;
    address = lookupData.address;
    branches = lookupData.locations;
  }

  return (
    <DeckGLGoogleMap
      currentAddress={address}
      centerCoordinate={coordinates}
      branches={branches}
      selectedBranch={selectedBranch}
    />
  );
};

export default Map;
